export class CookieBarClass {
	constructor(cookieName = 'cookie-consent', expiryDays = 7, timeout = 5000, bannerSel = '.cookie-bar', buttonSel = '.cookie-bar button') {
			this.cookieName = cookieName;
			this.expiryDays = expiryDays;
			this.timeout = timeout;
			this.banner = () => document.querySelector(bannerSel);
			this.buttonSel = buttonSel
			this.init();
	}

	init() {
		this.banner() && window.addEventListener( 'load', () => {
			setTimeout(() => this.showCookieBanner(),this.timeout);
			window.addEventListener('click', (e) => {
				let target = e.target.closest(this.buttonSel);
				target && this.acceptCookies()
			})
		})
	}

	getCookie(name) {
			let cookies = document.cookie.split('; ');
			for (let cookie of cookies) {
					let [key, value] = cookie.split('=');
					if (key === name) return value;
			}
			return null;
	}

	setCookie(name, value, days) {
			let expires = new Date();
			expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
			document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
	}

	acceptCookies() {
			this.setCookie(this.cookieName, 'accepted', this.expiryDays);
			this.banner()?.removeAttribute('open');
	}

	showCookieBanner() {
		!this.getCookie(this.cookieName) && this.banner()?.setAttribute('open','');
	}
}

export const CookieBar = new CookieBarClass();
